<template>
    <div class="loading-body">
        <div class="loading-wrapper">
            <font-awesome-icon icon="circle-notch" class="rotating"></font-awesome-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'loading'
        
    }
</script>

<style scoped>
.loading-body{
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.712);
    z-index: 10000000;
    text-align: center;
    font-size: 8rem;
    color: #5FA963;
}
.loading-wrapper{
    position: absolute;
    top: 30%;
    right: 0;
    left: 0;
}
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating {
    -webkit-animation: rotating 0.8s linear infinite;
    -moz-animation: rotating 0.8s linear infinite;
    -ms-animation: rotating 0.8s linear infinite;
    -o-animation: rotating 0.8s linear infinite;
    animation: rotating 0.8s linear infinite;
}
</style>